import * as React from "react";
import "./style.scss";
import { observer } from "mobx-react";

// Mobx
import HotelStore from "../../../../../stores/HotelStore";

// Components
import TextField from "../../../../../components/TextField";

// Resources
import strings from "../../../../../resources/strings";

interface IProps {
	hotelStore: HotelStore;
}

@observer
export default class HotelDataForm extends React.Component<IProps> {
	public render() {
		const { hotelStore } = this.props;
		return (
			<>
				<h2>{strings.hotel.edit.sections.data}</h2>
				<div className="hotelDataForm">
					<div className="hotelDataFormLeftPanel">
						<TextField
							label={strings.hotel.edit.fields.name}
							name="name"
							value={hotelStore.name}
							onChange={hotelStore.handleValueChange}
							disabled={hotelStore.loading}
							required={true}
						/>
						<TextField
							label={strings.hotel.edit.fields.description}
							name="description"
							multiline={true}
							value={hotelStore.description}
							onChange={hotelStore.handleValueChange}
							disabled={hotelStore.loading}
							required={true}
						/>
						<h3>{strings.hotel.edit.fields.reserveDisponibility.title}</h3>
						<div className="reserveDisponibility">
							<TextField
								label={strings.hotel.edit.fields.reserveDisponibility.start}
								name="start"
								multiline={true}
								value={hotelStore.start}
								onChange={hotelStore.handleValueChange}
								disabled={hotelStore.loading}
								required={true}
							/>
							<TextField
								label={strings.hotel.edit.fields.reserveDisponibility.end}
								name="end"
								multiline={true}
								value={hotelStore.end}
								onChange={hotelStore.handleValueChange}
								disabled={hotelStore.loading}
								required={true}
							/>
						</div>
					</div>
					<div className="hotelDataFormRightPanel">
						<TextField
							label={strings.hotel.edit.fields.omnibeesId}
							value={hotelStore.omnibeesId}
							disabled={true}
						/>
						<TextField
							label={strings.hotel.edit.fields.slogan}
							name="slogan"
							multiline={true}
							value={hotelStore.slogan}
							onChange={hotelStore.handleValueChange}
							disabled={hotelStore.loading}
						/>
						<TextField
							label={strings.hotel.edit.fields.email}
							name="email"
							multiline={true}
							value={hotelStore.email}
							onChange={hotelStore.handleValueChange}
							disabled={hotelStore.loading}
							required={true}
						/>
						<TextField
							label={strings.hotel.edit.fields.phone}
							name="phone"
							multiline={true}
							value={hotelStore.phone}
							onChange={hotelStore.handleValueChange}
							disabled={hotelStore.loading}
							required={true}
						/>
					</div>
				</div>
			</>
		);
	}
}
